import { localizeByKeyStatic } from "components/service";

export const localizeCommunicationLookupValue = (value?: string | null): string => {
  const normalizedValue = value?.trim();

  if (!normalizedValue) {
    return "";
  }

  return localizeByKeyStatic(normalizedValue);
};
